import { render, staticRenderFns } from "./inairequipment.vue?vue&type=template&id=ca7b95d6&scoped=true&"
import script from "./inairequipment.vue?vue&type=script&lang=ts&"
export * from "./inairequipment.vue?vue&type=script&lang=ts&"
import style0 from "./inairequipment.vue?vue&type=style&index=0&id=ca7b95d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca7b95d6",
  null
  
)

export default component.exports